import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { UserAccountRoles } from 'src/app/interfaces/user-account-roles';

import { BaseModel } from './base-model';

export class UserAccountRole extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static UserAccountRoleProperties: (
    | {
        property: keyof UserAccountRole;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof UserAccountRole;
        type: 'alias';
      }
    | {
        property: keyof UserAccountRole;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'displayName', type: 'column', dataType: 'string' },
    { property: 'role', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    UserAccountRole.UserAccountRoleProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        UserAccountRole.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        UserAccountRole.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        UserAccountRole.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(UserAccountRoleObject: Partial<UserAccountRole>) {
    super();

    UserAccountRole.UserAccountRoleProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = UserAccountRoleObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number | null;
  displayName?: string | null;
  role?: UserAccountRoles | null;
  createdAt?: Date;
  updatedAt?: Date;
}
